import React from 'react'
import PropTypes from 'prop-types'
import { constants, mixpanel } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Image from 'components/_new/ui/Image/Image'
import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import messages from './messages'

// resolve picture x2
import productsImage from './images/products.jpg'


const BottomSection = ({ redirectLink }) => (
  <WidthContainer>
    <Box mt="96" pb="24" alignCenter relative>
      <Text message={messages.title} size="28-40" semibold />
      <Box mt="24">
        <Button
          title={messages.buttonTitle}
          to={redirectLink}
          color="black"
          size="md"
          onClick={() => {
            mixpanel.track(constants.analyticsEvents.newThankYouPage.goToCatalogClick, {
              placement: 'bottom',
            })
          }}
        />
      </Box>
      <Box mt="24">
        <Image alt="" {...productsImage} />
      </Box>
    </Box>
  </WidthContainer>
)

BottomSection.propTypes = {
  redirectLink: PropTypes.string,
}


export default BottomSection
